export function printChequeDetails(cheque) {
  if (!cheque) return;
  const w = window.open("", "_blank", "width=800,height=900");
  if (!w) return;

  const rows = [
    ["Cheque issue code", cheque.cheque_issue_code || "—"],
    ["Bank", cheque.bank_name || "—"],
    ["Account number", cheque.account_number || "—"],
    ["Cheque number", cheque.cheque_number || cheque.cheque_no || "—"],
    ["Cheque type", cheque.type_name || "—"],
    ["Cheque date", cheque.cheque_date || "—"],
    ["Payee", cheque.payee_name || "—"],
    ["Purpose", cheque.purpose || "—"],
    ["Amount", cheque.amount != null ? `₹${Number(cheque.amount).toLocaleString("en-IN")}` : "—"],
    ["Voucher", cheque.voucher_number || cheque.voucher_no || "—"],
    ["Issued by", cheque.issued_by_name || "—"],
    ["Signatory", cheque.authorized_signatory_name || "—"],
    ["Status", cheque.status_name || "—"],
    ["Cleared", cheque.cheque_cleared ? "Yes" : "No"],
    ["Clearance date", cheque.clearance_date || "—"],
    ["Remarks", cheque.remarks || "—"],
  ];

  const body = rows
    .map(
      ([k, v]) =>
        `<tr><th style="text-align:left;padding:8px;border:1px solid #e2e8f0">${k}</th><td style="padding:8px;border:1px solid #e2e8f0">${v}</td></tr>`,
    )
    .join("");

  w.document.write(`
    <!DOCTYPE html><html><head><title>Cheque ${cheque.cheque_issue_code || cheque.id}</title>
    <style>body{font-family:system-ui,sans-serif;padding:24px;color:#0f172a}h1{font-size:1.25rem}</style></head>
    <body><h1>Cheque details</h1><table style="border-collapse:collapse;width:100%">${body}</table>
    <script>window.onload=function(){window.print();}</script></body></html>`);
  w.document.close();
}
